import React from 'react';

function Services() {
  return (
    <section className="tc-services-style1">
      <div className="content section-padding section-padding-x">
        <div className="container">
          <div className="title mb-80 text-center">
            <h5 className="color-666 text-uppercase wow"> our services </h5>
          </div>
          <div className="services">
            <div className="row">
              <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon">
                    {/* <i className="la la-hard-hat"></i> */}
                  </div>
                  <h5 className="fsz-24 mb-20"> Architectural Design </h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser1.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">                   
                  <b>Residential - </b>It will include custom-designed homes, luxury residences, and multi-family housing units.
                  <br/>
                  <b>Commercial - </b>It covers office spaces, retail environments, and hospitality projects such as hotels or restaurants.
                  <br/>
                  <b>Institutional - </b>This section encompasses educational facilities, healthcare centers, and civic buildings, such as government offices or community centers.
                  <br/>
                  </div>
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="icon">
                  </div>
                  <h5 className="fsz-24 mb-20">Interior Design</h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser2.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                  <b>Space Planning - </b>This will ensure efficient and effective layout design.
        <br/>
        <b>Custom Furnishing - </b>This helps you pick a solution that is tailored to your needs for furniture and fixtures.
        <br/>
        <b>Aesthetic Design - </b>It will brighten your place with the color scheme, lighting, and material selection best suited for you.
        <br/>
                   </div>
                </a>
              </div>

              <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <div className="icon">
                  </div>
                  <h5 className="fsz-24 mb-20">Project Management </h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser3.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                  <b>Budget management - </b>This will facilitate tracking and controlling project costs.
                  <br/>
                  <b>Contractor Coordination - </b>Managing relationships with builders and subcontractors is vital to transform your vision into reality.
                  <br/>
                  <b>Quality Assurance - </b>Ensuring construction is reaching the design specifications and standards.
                  <br/>
                 </div>
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <div className="icon">
                  </div>
                  <h5 className="fsz-24 mb-20">
                  Consulting services
                  </h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser4.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                  <b>Feasibility Studies - </b>This helps to evaluate project viability and potential challenges.
                  <br/>
                  <b>Regulatory Compliance - </b>It ensures proper navigation of zoning laws, building codes, and permits.
                  <br/>
                  <b>Sustainability Consulting - </b>This facilitates the implementation of green building practices and certifications.
                  <br/>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="text-center">
            <a
              href="/innerpages/services"
              className="butn rounded-pill mt-80 hover-bg-black bg-orange1 text-white"
            >
              <span>
                More services
                <i className="small ms-1 ti-arrow-top-right"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div className="ser-img">
        <img src="/home1/assets/img/services/ser.jpg" alt="" />
      </div>
    </section>
  );
}

export default Services;
